import React, { useContext } from 'react'
import { LanguageContext, NotificationContext } from '../context'
import moment from 'moment'
import { DATE_FORMAT, TIME_FORMAT } from '../utils/constants'

function ShareModal({ showModal, onClose, event }) {

  const { toast } = useContext(NotificationContext)
  const { t } = useContext(LanguageContext)

  const handleCopyLink = () => {
    navigator.clipboard.writeText(`${window.location.origin}/event/${event.id}`)
    toast({ message: t('share.link_copied'), variant: 'success' })
  }

  const emailShareUrl = () => {
    const subject = t('share.email_subject', { eventName: event.title, eventDate: moment(event.start).format(DATE_FORMAT) })
    const body = t('share.email_body', {
      eventName: event.title,
      eventAddress: event.address?.formatted || '',
      eventDate: moment(event.start).format(DATE_FORMAT),
      eventTime: moment(event.start).format(TIME_FORMAT),
      link: `${window.location.origin}/event/${event.id}`
    })
    return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
  }

  const shareVia = (method) => () => {
    let url = ''
    const shareMessage = t('share.default_message', { eventName: event.title, eventDate: moment(event.start).format(DATE_FORMAT) , eventAddress: event.address?.formatted || '' })
    switch (method) {
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(`${shareMessage} - ${window.location.origin}/event/${event.id}`)}`
        break
      case 'facebook':
        url = `https://www.facebook.com/dialog/share?app_id=335390579666157&display=popup&href=${encodeURIComponent(`${window.location.origin}/event/${event.id}`)}`
        break
      case 'email':
        url = emailShareUrl()
        break
      default:
        break
    }
    window.open(url, '_blank')
  }

  return (
    <div className={`w-full ${showModal ? '' : 'hidden'}`}>
      <div
        className="justify-center items-center z-50 rounded-lg modal-container">
        <div className="flex items-start justify-between pt-16 pb-9 px-5  ">
          <h3 className="modal-title">
            {t('share.title')}
          </h3>
          <button
            className="p-1 bg-transparent text-black text-3xl absolute top-2 right-4"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        {/*body*/}
        <div className="modal-box">
          <div className='flex mb-10'>
            <div className='w-1/2 px-4 cursor-pointer flex-col flex' onClick={shareVia('whatsapp')}>
              <img src='/WhatsApp1.png' className='w-20 p-2 mx-auto mb-6' />
              <span className='social-title'>Whatsapp</span>
            </div>
            {/* <div className='w-1/3 px-4 cursor-pointer flex-col flex'>
              <FacebookMessengerShareButton appId="335390579666157" url={`${window.location.origin}/event/${event.id}`}>
                <div className='flex-col flex'>
                  <img src='/facebook-logo.svg' className='w-20 p-2 mx-auto mb-6' />
                  <span className='social-title'>Facebook</span>
                </div>
              </FacebookMessengerShareButton>
            </div> */}
            <div className='w-1/2 px-4 cursor-pointer flex-col flex' onClick={shareVia('email')}>
              <img src='/Circle-icons-mail.svg' className='w-20 p-2 mx-auto mb-6' />
              <span className='social-title'>Email</span>
            </div>
          </div>
          <div className='separator-line'>
            <span>{t('share.copy_url_title')}</span>
          </div>
          <div className='border url-section'>{`${window.location.origin}/event/${event.id}`}</div>
          <button onClick={handleCopyLink} className='mid w-full'>{t('share.copy_url_button')}</button>

        </div>
      </div>
      <div className="fixed inset-0 z-40 modal-bg" onClick={onClose}></div>
    </div>
  )
}

export default ShareModal
